import { IconButton, Tooltip } from '@mui/material';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';

type SheduleFocusTimeButtonProps = {
  ariaLabel?: string;
  onClick: () => void;
  title?: string;
};

const BUTTON_SX = {
  width: 36,
  height: 36,
  border: '1px solid',
  borderColor: 'primary.main',
  borderRadius: '50%',
  color: 'primary.main',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1,
} as const;

const SheduleFocusTimeButton = ({
  ariaLabel = 'Schedule focus time',
  onClick,
  title = 'Schedule focus time',
}: SheduleFocusTimeButtonProps) => (
  <Tooltip title={title}>
    <IconButton aria-label={ariaLabel} sx={BUTTON_SX} onClick={onClick}>
      <EditCalendarOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

export default SheduleFocusTimeButton;
